module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("心仪职位太多，每天申请次数不够用？非会员每天只有15次全职职位申请机会，会员拥有25次全职职位申请机会，求职效率翻倍提升！")])]), _vm._v(" "), _c('div', {
    staticClass: "tdtq-bg"
  }, [_c('img', {
    staticClass: "tdtq-bg-img",
    attrs: {
      "src": "https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/r9o96ilm__w1068_h1108.png"
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("投递翻倍")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("非会员每天只有15次全职职位申请机会，会员拥有25次全职职位申请机会，求职效率翻倍提升！")])]), _vm._v(" "), _c('div', {
    staticClass: "tdtq-bg"
  }, [_c('img', {
    staticClass: "tdtq-bg-img",
    attrs: {
      "src": "https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/r9o96ilm__w1068_h1108.png"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee8e960"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/TdtqDialog.vue
// module id = OHt5
// module chunks = 1